// extracted by mini-css-extract-plugin
export default {"component":"KRA5oFsK","primary":"OZgXvdD6","secondary":"zRQ8XxFE","text":"Zhe8SZeH","alternative":"IGAw_rls"};